import { Injectable } from "@angular/core";
import { AbstractParser } from "../../parser";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { parseCompany, parseCompanyRemainingLimit } from "./company-parse-functions";
import { CompanyRemainingLimit } from "src/app/ui/models/domains/pbm/companies/company-remaining-limit";

@Injectable()
export class CompanyParser extends AbstractParser<Company> {
  parse(payload: any): Company {
    return parseCompany(payload);
  }

  parseCompanyRemainingLimit(payload: any): CompanyRemainingLimit {
    return parseCompanyRemainingLimit(payload);
  }
}
